<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--   Main Content Start Here   -->
    <main>
      <section class="dashboard_wraper">
        <div class="container_large">
          <div class="row">
            <!-- starting side bar -->
            <sidebar-component></sidebar-component>
            <!-- ending sidebar  -->
            <div class="col-md-12 col-lg-9">
              <div class="dashboard_card">
                <div class="row">
                  <div class="col-6">
                    <h2>Faqs</h2>
                  </div>
                  <div class="col-6 text-right">
                    <router-link :to="{ name: 'admin-add-faq' }">
                      <button
                        type="button"
                        class="button primary_button"
                        aria-label="Close"
                      >
                        Add new FAQ
                      </button>
                    </router-link>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Question</th>
                        <th scope="col">Answer</th>
                        <th scope="col">Added on</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody v-if="faqs && faqs.length">
                      <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr v-for="data in faqs" :key="data">
                       

                        <td>
                          <span v-if="data.question">
                              <span v-if="data.question.length>40">
                                  {{data.question.substr(0,40)}}...
                              </span>
                              <span v-if="data.question.length<=40">
                                  {{data.question}}
                              </span>
                          </span>
                        </td>

                        <td>
                          <!-- {{ data.answer ? data.answer : "" }} -->
                          <span v-if="data.answer">
                              <span v-if="data.answer.length>30">
                                  {{data.answer.substr(0,30)}}...
                              </span>
                              <span v-if="data.answer.length<=30">
                                  {{data.answer}}
                              </span>
                          </span>
                        </td>
                        <td>{{ data.formated_created }}</td>

                        <td>
                          <!-- <router-link
                            :to="{
                              name: 'admin-update-faq',
                              params: { id: data.id },
                            }"
                            class="table_action"
                            ><img src="/src/assets/images/view-icon.svg" alt=""
                          /></router-link> -->
                          <router-link
                            :to="{
                              name: 'admin-update-faq',
                              params: { id: data.id },
                            }"
                            class="table_action"
                            ><img src="/src/assets/images/edit-icon.svg" alt=""
                          /></router-link>
                          <a
                            href="#"
                            class="table_action"
                            @click="deleteModal(data.id)"
                            ><img src="/src/assets/images/del-icon.svg" alt=""
                          /></a>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-if="!faqs || !faqs.length">
                      <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr>
                        You don't have created any Faqs yet
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->

    <!-- Delete Modal -->
    <div
      class="modal fade"
      id="delete_faq"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Delete</h2>
              <p>Are you sure want to delete this item?</p>
              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  type="button"
                  class="button primary_button"
                  @click.prevent="deleteFaq()"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "./sidebar";

import faqsApis from "../../Apis/faqs";
import moment from "moment";
export default {
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      faqs: null,
      deleted_id: null,
    };
  },
  methods: {
    deleteModal(id) {
      this.deleted_id = id;

      var myModal = new bootstrap.Modal(document.getElementById("delete_faq"));
      myModal.show();
    },
    async deleteFaq() {
      console.log("dddd");
      this.loader = true;

      await faqsApis.requestFaqs("delete", { id: this.deleted_id });

      this.deleted_id = null;
      this.getFaqs();
      var myModal = new bootstrap.Modal(document.getElementById("delete_faq"));
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");
      setTimeout(() => {
        this.loader = false;
      }, 1000);
    },

    async getFaqs() {
      const response = (await faqsApis.requestFaqs("get", "")).data;
      if (response) {
        response.forEach((element) => {
          element.formated_created = moment(element.created_at).format(
            "MM-DD-YYYY"
          );
          return element;
        });
        this.faqs = response;
      }
    },
  },

  async created() {
    this.getFaqs();

    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>
<style scoped>
.text-right {
  text-align: end !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/listFaqs.vue